import React, { useEffect, useState } from 'react';

export const useAppCode = (getAppBaseURL, shouldRunDefaultAppCode) => {
  const [appCode, setAppCode] = useState('');
  const handleAppCodeChange = (event) => {
    setAppCode(event.target.value);
  };
  useEffect(() => {
    if (shouldRunDefaultAppCode) {
      getAppBaseURL('');
    }
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (appCode.length >= 2) {
        getAppBaseURL(appCode);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [appCode]);
  return { appCode, handleAppCodeChange };
};
